export * from './lib/i18n.module';
export * from './lib/i18n.service';
export * from './lib/custom-title-strategy.service';
export * from './lib/custom-title-with-suffix-strategy.service';
export * from './lib/components/lang-droplist/lang-droplist.component';
export * from './lib/components/langComponents.module';
